import { FC } from "react";
import { HelpCircle } from "untitledui-js-base";

export const Card: FC<{
  title: string;
  content: string;
  subContent: string;
  tooltip: string;
}> = ({ title, content, subContent }) => {
  return (
    <div className="rounded-lg p-6 border border-alpha-100 bg-background-1000 shadow-xs">
      <div className="mb-1 flex justify-between items-center">
        <p className="text-content-1000 text-sm">{title}</p>
        <HelpCircle size="20" className="stroke-content-200" />
      </div>
      <h1 className="text-2xl text-content-1000 font-bold">{content}</h1>
      {subContent ? (
        <p className="text-primary-500 text-sm">{subContent}</p>
      ) : null}
    </div>
  );
};
